import React from 'react';
import PropTypes from "prop-types";
import './text.scss';

const Text = ({children, className, Component, ellipsis, fontSize, fontWeight, color, ...rest}) => {
  return <Component
    className={`Suc-text ${className} ${ellipsis ? 'Suc-ellipsis' : ''} Suc-font-size-${fontSize} Suc-font-weight-${fontWeight} Suc-font-color-${color}`} {...rest}>
    {children}
  </Component>
}

Text.propTypes = {
  /** custom classname */
  className: PropTypes.string,
  /** Component to render or valid html tag as string */
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Should Text have ellipsis when overflow */
  ellipsis: PropTypes.bool,
  /** text fontSize */
  fontSize: PropTypes.oneOf([13, 14, 15, 16, 20, 24]),
  /** text fontWeight */
  fontWeight: PropTypes.oneOf([400, 600]),
  /** text color */
  color: PropTypes.oneOf(['regular', 'primary', 'grey']),
}

Text.defaultProps = {
  className: '',
  Component: 'div',
  ellipsis: true,
  fontSize: 14,
  fontWeight: 400,
  color: 'regular'
}

export default Text;
